export default __webpack_public_path__ + "static/media/borracha.7ba61cd2.png";